import { render, staticRenderFns } from "./AnswerKey.vue?vue&type=template&id=47056514&scoped=true&"
import script from "./AnswerKey.vue?vue&type=script&lang=js&"
export * from "./AnswerKey.vue?vue&type=script&lang=js&"
import style0 from "./AnswerKey.vue?vue&type=style&index=0&id=47056514&prod&lang=scss&scoped=true&"
import style1 from "./AnswerKey.vue?vue&type=style&index=1&id=47056514&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47056514",
  null
  
)

export default component.exports